import { useMemo } from 'react';

import type { UpdateTaskItemAttrs } from '../taskItemChipsUtils';
import type { ElementChipCallbackSet } from './useElementChipCallbacks';

/**
 * Assignment callbacks for task-item chips. Deleting an assignment (or the empty
 * "Assign to" placeholder) clears the assignees and turns off the slot, mirroring
 * the element `removeTaskAssignments` (`showAssignments: false`, `assignments: []`).
 */
export const useAssignmentTaskItemChipCallbacks = ({
    updateAttributes,
    canModifyAssignments,
}: {
    updateAttributes: UpdateTaskItemAttrs;
    canModifyAssignments: boolean;
}): ElementChipCallbackSet =>
    useMemo(
        () => (chip) => {
            if (chip.type !== 'assignment' && chip.type !== 'assignment-placeholder') return {};

            return {
                canModify: canModifyAssignments,
                onDeleteKeyDown: (event) => {
                    if (!canModifyAssignments) return;

                    event.preventDefault();
                    event.stopPropagation();
                    updateAttributes({ assignments: [], showAssignments: false });
                },
            };
        },
        [canModifyAssignments, updateAttributes],
    );
